export function someMutation (/* state, value */) {
}
